import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
// import { getToken } from '@/utils/auth'

const getQueryVariable = function (variable){
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
             var pair = vars[i].split("=");
             if(pair[0] === variable){return pair[1];}
    }
    return(false);
}

let locale;
localStorage.getItem('locale') ? locale = localStorage.getItem('locale') : locale = 'zh';

if(getQueryVariable('type')==='en'||getQueryVariable('type')==='ennews'){
  locale = 'en';
}

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url   http://admin.fstcb.com
  baseURL:'https://admin.uniceramics.com.cn',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})
// console.log(process.env.VUE_APP_BASE_API);
// request interceptor request拦截器
service.interceptors.request.use(

  config => {
    // console.log(config)
    if(config.url.indexOf('?')===-1){
      config.url = config.url+'?lang='+locale;
    }else{
      config.url = config.url+'&lang='+locale;
    }
    
    // do something before request is sent

    // if (store.getters.token) {
      // console.log("request拦截器");
      // 让每个请求携带token--['X-Token']为自定义key
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['X-Token'] = getToken()
    // }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(

  response => {
    const res = response.data
    if(response.status===200){
      return res
    }else{
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
    }
  },
  error => {
    console.log('err' + error)
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 1 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service
